import { fetchToken } from "../helpers/fetch";
import { const_routes } from "../helpers/const_routes";
import { debugLogActions, debugErrorActions } from "../helpers/debugHelper";

export const searchUsersLite = async ({ query, role, moduleName, size = 20 }) => {
  if (!query || query.length < 2) {
    return [];
  }

  try {
    const params = new URLSearchParams();
    params.append("search", query);
    if (role) {
      params.append("role", role);
    }
    if (moduleName) {
      params.append("module", moduleName);
    }
    if (size) {
      params.append("size", size);
    }

    const endpoint = `search-by-role-module?${params.toString()}`;
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USERS}`,
      endpoint
    );

    if (!resp.ok) {
      debugErrorActions(":: userSearchActions, searchUsersLite", { endpoint, status: resp.status });
      return [];
    }

    const body = await resp.json();
    debugLogActions(":: userSearchActions, searchUsersLite", { endpoint, body });

    if (body.ok) {
      return body.users || [];
    }

    return [];
  } catch (error) {
    debugErrorActions(":: userSearchActions, searchUsersLite", { error, query });
    return [];
  }
};

export const listFlowRoleUsers = async (roles = [], catalogmoduleId) => {
  const keys = (Array.isArray(roles) ? roles : [roles])
    .map((item) => String(item || "").trim().toLowerCase())
    .filter(Boolean);
  if (!keys.length) {
    return [];
  }

  try {
    const batches = await Promise.all(keys.map(async (role) => {
      const params = new URLSearchParams();
      params.append("role", role);
      if (catalogmoduleId) {
        params.append("catalogmodule_id", String(catalogmoduleId));
      }
      const endpoint = `roleUsers?${params.toString()}`;
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_FLOW_MODULE_CONFIG}`,
        endpoint
      );
      if (!resp.ok) {
        debugErrorActions(":: userSearchActions, listFlowRoleUsers", { endpoint, status: resp.status });
        return [];
      }
      const body = await resp.json();
      if (!body.ok) {
        return [];
      }
      return (body.users || []).map((user) => ({
        ...user,
        roles: [body.role].filter(Boolean)
      }));
    }));

    const byId = new Map();
    batches.flat().forEach((user) => {
      const prev = byId.get(user.id);
      if (!prev) {
        byId.set(user.id, { ...user, roles: [...(user.roles || [])] });
        return;
      }
      prev.roles = [...new Set([...(prev.roles || []), ...(user.roles || [])])];
    });
    return [...byId.values()];
  } catch (error) {
    debugErrorActions(":: userSearchActions, listFlowRoleUsers", { error, roles: keys });
    return [];
  }
};

export const listUsersByRoles = async (roles = []) => {
  const names = (Array.isArray(roles) ? roles : [roles])
    .map((item) => String(item || "").trim())
    .filter(Boolean);
  if (!names.length) {
    return [];
  }

  try {
    const params = new URLSearchParams();
    params.append("roles", names.join(","));
    const endpoint = `by-roles?${params.toString()}`;
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USERS}`,
      endpoint
    );

    if (!resp.ok) {
      debugErrorActions(":: userSearchActions, listUsersByRoles", { endpoint, status: resp.status });
      return [];
    }

    const body = await resp.json();
    debugLogActions(":: userSearchActions, listUsersByRoles", { endpoint, count: body?.users?.length });
    if (body.ok) {
      return body.users || [];
    }
    return [];
  } catch (error) {
    debugErrorActions(":: userSearchActions, listUsersByRoles", { error, roles: names });
    return [];
  }
};
